import React, { useEffect, useState } from 'react';
import SearchBar from "@/components/searchBar/SearchBarAccounts";
import TablePatientsList from "@/components/practitioner/TablePatientsList";
import axios from 'axios';
import { TUsersList } from '@/api/DashboardTypes';

const PatientsList: React.FC = () => {
  const [data, setData] = useState<TUsersList[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPatients, setCurrentPatients] = useState<TUsersList[]>([]);

  useEffect(() => {
    axios.get('/practitioner/patients')
      .then(response => {
        setData(response.data);
        setCurrentPatients(response.data); // Initialement, tous les comptes sont visibles
      })
      .catch(error => {
        console.error("Erreur lors de la récupération des données:", error);
      });
  }, []);

  useEffect(() => {
    const filterData = () => {
      const searchTerms = searchTerm.toLowerCase().split(" ").filter(term => term.trim() !== "");
      const filtered = data.filter(account =>
        searchTerms.every(term =>
          account.firstName.toLowerCase().includes(term) ||
          account.lastName.toLowerCase().includes(term)
        )
      );
      setCurrentPatients(filtered);
    };

    if (searchTerm) {
      filterData();
    } else {
      setCurrentPatients(data);
    }
  }, [searchTerm, data])

  return (
    <div>
      <SearchBar onSearchChange={setSearchTerm} />
      <div className="w-full flex justify-center">
        <TablePatientsList patientsList={currentPatients} setPatientsList={setCurrentPatients}/>
      </div>
    </div>
  );
}

export default PatientsList;
